export default {
  nextAction: 'Next Action',
  CANDIDATE_ACCEPT_CONTACT_REQUEST: 'Awaiting contact request acceptance',
  CANDIDATE_ANSWER_PENDING_QUESTION: 'Awaiting question answers',
  RECRUITER_BOOKMARK_CANDIDATE: 'Engage Candidate',
  RECRUITER_MONETIZE_CANDIDATE: 'Engage Candidate',
  CANDIDATE_ADD_JOB_INTEREST: 'No matching job interest',
  CANDIDATE_UPDATE_EXPERIENCE: 'Inadequate experience',
  CANDIDATE_UPDATE_WHERE_TO_WORK: 'No defined work location',
  CANDIDATE_WAIT_FOR_OPEN_REQUISITION: 'No open requisitions',
  CANDIDATE_UPDATE_AVAILABILITY: 'Awaiting availability update',
  CANDIDATE_REVIEW_ANSWER: 'Awaiting answer review',
  CANDIDATE_UPDATE_SURPLUS_EXPERIENCE: 'Over experienced',
  RECRUITER_REVIEW_FOR_PAUSED: 'Review wrong question answers',
  RECRUITER_REVIEW_FOR_KNOCKOUT_FROM_QA: 'Answered must pass question incorrectly',
  RECRUITER_SEND_MODERN_HIRE_REQUEST: 'Awaiting competency Evaluation request',
  RECRUITER_SEND_LE_REQUEST: 'Send Language Evaluation Test',
  RECRUITER_SEND_APPOINTMENT_REQUEST: 'Eligible for interview request',
  RECRUITER_SEND_OFFER: 'Eligible for making offer',
  RECRUITER_ADD_TOKENS: 'Add Monetization Token',
  CANDIDATE_COMPLETE_MODERN_HIRE: 'Awaiting Modern Hire completion',
  TO_BE_DISMISSED_MH: 'Awaiting Dismissal - Competency test failed',
  CANDIDATE_COMPLETE_LE: 'Awaiting Language Evaluation completion',
  RECRUITER_EVALUATE_LE: 'Review Language Evaluation results',
  TO_BE_DISMISSED_LE: 'Awaiting Dismissal - Language Evaluation failed',
  CANDIDATE_UPDATE_MAX_WORKING_HOURS: 'Less working hours per week',
  CANDIDATE_ACCEPT_APPOINTMENT_REQUEST: 'Awaiting interview acceptance',
  RECRUITER_UPDATE_AVAILABILITY: 'Insufficient interview availability',
  ATTEND_INTERVIEW: 'Interview scheduled',
  RECRUITER_RESCHEDULE_INTERVIEW: 'Reschedule interview',
  RECRUITER_RESCHEDULE_INTERVIEW_CANDIDATE_NO_SHOW: 'Incomplete Interview - Candidate No show',
  RECRUITER_RESCHEDULE_INTERVIEW_RECRUITER_NO_SHOW: 'Incomplete Interview - Recruiter No show',
  RECRUITER_INCOMPLETE_INTERVIEW_CANDIDATE_NO_SHOW: 'Incomplete Interview - Candidate No show',
  RECRUITER_INCOMPLETE_INTERVIEW_OR_RECRUITER_NO_SHOW: 'Incomplete Interview - Recruiter No show',
  RECRUITER_NEED_TO_RATE: 'Need to rate interview',
  RECRUITER_DISMISS_CANDIDATE_FOR_LOW_RATING: 'Interview Completed - Low rating',
  CANDIDATE_WAIT_FOR_INTERVIEW_SLOT: 'Maximum concurrent interviews reached',
  CANDIDATE_WAIT_FOR_AVAILABILITY_SLOT: 'Add Availability',
  CANDIDATE_WAIT_FOR_INTERVIEW_THRESHOLD: 'Recently interviewed',
  CANDIDATE_ACCEPT_OFFER: 'Awaiting offer acceptance',
  RECRUITER_SEND_SCREENING: 'Send Background Check Verification',
  RECRUITER_SEND_HIRE_FORM: 'Send Hire Form',
  RECRUITER_SEND_I9_REQUEST: 'Send I9 Verification',
  RECRUITER_HIRE_CANDIDATE: 'Finalize Hire',
  OFFER_REJECTED_BY_RECRUITER_REVIEW_CANDIDATE: 'Review Candidate - Offer Rejected',
  TO_BE_DISMISSED_OFFER_REJECTED: 'Awaiting dismissal - Offer Declined',
  REVIEW_CANDIATE_OFFER_REJECTED_SEEKER: 'Review Candidate - Offer Declined',
  RECRUITER_SEND_NEW_OFFER: 'Eligible for making offer',
  TO_BE_DISMISSED_OFFER_REVOKED: 'Awaiting dismissal - Offer Revoked',
  REVIEW_CANDIDATE_OFFER_REVOKED: 'Review Candidate - Offer Revoked',
  CANDIDATE_COMPLETE_SCREENING: 'Awaiting background check completion',
  RECRUITER_REVIEW_SCREENING_REPORT: 'Review background check results',
  CANDIDATE_FILL_HIRE_FORM: 'Awaiting Hire Form completion',
  RECRUITER_RESPOND_HELP_REQUEST: 'Respond to Hire Form help request',
  RECRUITER_EVALUATE_HIRE_FORM: 'Review completed Hire Form',
  TO_BE_DISMISSED_HIRE_FORM_REJECTED: 'Awaiting Dismissal - Hire form rejected',
  CANDIDATE_FILL_I9: 'Awaiting I-9 completion',
  CANDIDATE_RESUBMIT_I9: 'Awaiting I-9 resubmission',
  RECRUITER_EVALUATE_I9: 'Review I-9 submission',
  END_OF_WORKFLOW: '',
};
